(() => {
  'use strict';
  if (window.__uniOfferRefinement) return;
  window.__uniOfferRefinement = true;
  const boot = (scope = document) => {
    scope.querySelectorAll('[data-nav-group]').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      const summary = group.querySelector('summary');
      let closeTimer;
      const close = () => { clearTimeout(closeTimer); group.open = false; };
      const sync = () => summary.setAttribute('aria-expanded', String(group.open));
      group.addEventListener('toggle', () => {
        sync();
        if (group.open) group.parentElement.querySelectorAll('[data-nav-group]').forEach(other => { if (other !== group) other.open = false; });
      });
      group.addEventListener('pointerenter', event => {
        clearTimeout(closeTimer);
        if (event.pointerType === 'mouse' && matchMedia('(min-width: 990px) and (hover: hover)').matches) group.open = true;
      });
      group.addEventListener('pointerleave', () => { closeTimer = setTimeout(() => { if (!group.contains(document.activeElement)) close(); }, 260); });
      group.addEventListener('focusout', () => requestAnimationFrame(() => { if (!group.contains(document.activeElement)) close(); }));
      group.addEventListener('keydown', event => {
        if (event.key === 'Escape' && group.open) { event.preventDefault(); event.stopPropagation(); close(); summary.focus(); }
        if (event.key === 'ArrowDown' && event.target === summary) { event.preventDefault(); group.open = true; group.querySelector('a')?.focus(); }
      });
      document.addEventListener('click', event => { if (!group.contains(event.target)) close(); });
      sync();
    });
    let config;
    try { config = JSON.parse(document.getElementById('uni-offer-config')?.textContent || '{}'); } catch { return; }
    if (!config.programs) return;
    const params = new URLSearchParams(location.search);
    const validMode = value => ['distancia', 'presencial'].includes(value) ? value : 'distancia';
    const programme = document.querySelector('uni-program[data-dual="true"],uni-program[data-distance-only="true"]');
    const modeFor = (id, value) => config.distanceOnly?.includes(id) ? 'distancia' : validMode(value);
    let mode = validMode(params.get('modalidad'));
    const description = value => `${config.label[value]} · ${config.duration[value]} · ${config.place[value]}`;
    const updateWhatsapp = (container, id, value) => {
      if (!config.programs[id]) return;
      [...(container.matches('a[href^="https://wa.me/"]') ? [container] : []), ...container.querySelectorAll('a[href^="https://wa.me/"]')].forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('text', config.text.whatsapp.replace('{programa}', config.programs[id]).replace('{modalidad}', description(value)).replace('{periodo}', config.period).replace('{id}', id));
        link.href = url.href;
      });
    };
    const changeProgramme = (value, updateAddress = false) => {
      const previousMode = programme?.dataset.selectedModality;
      mode = modeFor(programme?.dataset.programId, value);
      if (!programme) return;
      programme.dataset.selectedModality = mode;
      programme.querySelectorAll('[data-for-modality]').forEach(item => { item.hidden = item.dataset.forModality !== mode; });
      programme.querySelectorAll('[data-modality-selector] input').forEach(input => { input.checked = input.value === mode; });
      const id = programme.dataset.programId;
      programme.querySelectorAll('[data-program-cta]').forEach(link => {
        try {
          const url = new URL(link.getAttribute('href'), location.href);
          if (url.origin !== location.origin) return;
          url.searchParams.set('programa', id); url.searchParams.set('modalidad', mode); url.searchParams.set('periodo', config.period);
          link.href = url.pathname + url.search + url.hash;
        } catch {}
      });
      programme.querySelectorAll('[data-brief-dialog]').forEach(dialog => {
        const url = new URL(dialog.dataset.shareUrl);
        url.searchParams.set('modalidad', mode);
        dialog.dataset.shareUrl = url.href;
        const link = dialog.querySelector('.uni-program-brief__url');
        if (link) { link.href = url.href; link.textContent = url.href; }
      });
      updateWhatsapp(programme, id, mode);
      updateWhatsapp(document.querySelector('[data-whatsapp-float]') || programme, id, mode);
      if (updateAddress) {
        try { const url = new URL(location.href); url.searchParams.set('modalidad', mode); history.replaceState(history.state, '', url.href); } catch {}
      }
      document.dispatchEvent(new CustomEvent('uni:modalitychange', {detail:{id,mode,previousMode,userInitiated:updateAddress}}));
    };
    if (programme && !programme.dataset.offerBound) {
      programme.dataset.offerBound = 'true';
      programme.querySelector('[data-modality-selector]')?.addEventListener('change', event => changeProgramme(event.target.value, true));
      changeProgramme(mode);
    }
    scope.querySelectorAll('[data-uni-contact][data-mode="institutional"][data-purpose="admissions"]').forEach(section => {
      if (section.dataset.offerBound) return;
      section.dataset.offerBound = 'true';
      const form = section.querySelector('form');
      const field = form?.querySelector('[data-contact-modality]');
      if (!field) return;
      const select = form.querySelector('[data-contact-program]');
      const id = () => select?.selectedOptions[0]?.dataset.programId || section.dataset.programId;
      const duration = form.querySelector('[data-contact-duration]');
      const wrapper = field.closest('[data-modality-field]');
      const update = (requested = field.value) => {
        const key = id(), dual = Boolean(config.programs[key]);
        const selectedMode = modeFor(key, requested);
        const returnField = form.elements.namedItem('return_to');
        if (returnField) {
          try { const url = new URL(returnField.value, location.origin); if (key) url.searchParams.set('programa', key); else url.searchParams.delete('programa'); if (dual) { url.searchParams.set('modalidad', selectedMode); url.searchParams.set('periodo', config.period); } else { url.searchParams.delete('modalidad'); url.searchParams.delete('periodo'); } returnField.value = url.pathname + url.search + url.hash; } catch {}
        }
        wrapper.hidden = !dual; field.disabled = !dual; duration.disabled = !dual;
        const period = form.querySelector('[data-contact-period]');
        if (period) { period.disabled = !dual; period.value = dual ? config.period : ''; period.closest('[data-period-field]').hidden = !dual; const label = form.querySelector('[data-contact-period-text]'); if (label) label.textContent = config.period; }
        Array.from(field.options).forEach(option => { option.disabled = config.distanceOnly?.includes(key) && option.value !== 'distancia'; option.hidden = option.disabled; });
        if (!dual) {
          section.querySelectorAll('a[data-offer-original-href]').forEach(link => { link.href = link.dataset.offerOriginalHref; });
          return;
        }
        field.value = selectedMode;
        duration.value = config.duration[field.value];
        wrapper.querySelector('[data-modality-context]').textContent = config.description[field.value];
        section.querySelectorAll('a[href^="https://wa.me/"]').forEach(link => { if (!link.dataset.offerOriginalHref) link.dataset.offerOriginalHref = link.href; });
        updateWhatsapp(section, key, field.value);
        document.querySelectorAll('[data-admission-program]').forEach(entry => {
          if (entry.dataset.admissionProgram !== key) return;
          const link = entry.querySelector('.uni-admission__program-link');
          if (link) { try { const url = new URL(link.href); url.searchParams.set('modalidad', field.value); link.href = url.href; } catch {} }
        });
      };
      let previousProgram = id();
      select?.addEventListener('change', () => {
        const nextProgram = id();
        update(nextProgram === previousProgram ? field.value : 'distancia');
        previousProgram = nextProgram;
      });
      field.addEventListener('change', () => { update(); if (programme?.dataset.programId === id()) changeProgramme(field.value, true); });
      document.addEventListener('uni:modalitychange', event => { if (event.detail.id === id()) update(event.detail.mode); });
      update(programme?.dataset.selectedModality || params.get('modalidad') || 'distancia');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), {once:true});
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  window.addEventListener('popstate', () => {
    const value = new URLSearchParams(location.search).get('modalidad');
    const control = document.querySelector(`[data-modality-selector] input[value="${value === 'presencial' ? 'presencial' : 'distancia'}"]`);
    if (control) { control.checked = true; control.dispatchEvent(new Event('change', {bubbles:true})); }
  });
})();
